import type { RequestConfig } from '@customTypes/index';
import type { WorkDto, WorkRequestItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type CreateWorkRequestParams = RequestConfig<WorkDto>;

export const createWorkRequest = async ({
  params,
  config
}: CreateWorkRequestParams) =>
  api.post<WorkRequestItemDto>(`/api/work/requests`, params, config);
